const boolToYesNo = value => (value ? 'Yes' : 'No')

export default boolToYesNo
